import React, { Component } from 'react'
import { DragSource } from 'react-dnd';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

/* drag sources */
const itemSource = {
    beginDrag(props) {
        return props.item;
    },
    endDrag(props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }
        let target = monitor.getDropResult()
        // props.checkOverwrite(props.item, target.week, target.day, props.course_id, target.dayValue)
        props.onDrop(props.item, target.week, target.day, target.course_id)
        return true
    }
}

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
}

class DraggableOrphanLesson extends Component {

    render() {
        let { connectDragSource, isDragging } = this.props;

        if (this.props.alreadySelected) {
            return (
                connectDragSource(
                    <div style={{ opacity: isDragging ? 0.5 : 1 }}>
                        <ExpansionPanel style={{ backgroundColor: this.props.alreadySelected ? '#DDDDDD' : 'white' }} >
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>{this.props.item.LessonName}</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Typography>
                                    {this.props.item.LessonDescription}
                                </Typography>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </div>)
            )
        }

        return (
            connectDragSource(
                <div style={{ opacity: isDragging ? 0.5 : 1 }}>
                    <ExpansionPanel style={{ backgroundColor: this.props.alreadySelected ? '#DDDDDD' : 'white' }} >
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>{this.props.item.LessonName}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Typography>
                                {this.props.item.LessonDescription}
                            </Typography>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>)
        );
    }
}

export default DragSource('item', itemSource, collectSource)(DraggableOrphanLesson);


// WEBPACK FOOTER //
// src/main/content/course/scheduleComponents/DraggableOrphanLesson.js